module.exports = __webpack_public_path__ + "static/img/a022.3502678.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a022.jpg
// module id = uCQc
// module chunks = 0